import { createSlice } from "@reduxjs/toolkit";
import { IDataSlice } from "@/shared/interfaces/patientPage";

const initialState: IDataSlice = {
    data: [],
    dataLength: 0,
    activepage: 1,
};

const dataSlice = createSlice({
    name: "data",
    initialState,
    reducers: {
        setData: (state, action) => {
            state.data = [...action.payload];
        },
        setDataLength: (state, action) => {
            state.dataLength = action.payload;
        },
        setActivePage: (state, action) => {
            state.activepage = action.payload;
        },
        addItemToData: (state, action) => {
            state.data = [action.payload, ...state.data];
            const newLength = state.dataLength + 1;
            state.dataLength = newLength;
        },
        deleteItemFromData: (state, action) => {
            const newArr = state.data.filter(
                item => item._id !== action.payload,
            );
            state.data = [...newArr];
            const newLength = state.dataLength - 1;
            state.dataLength = newLength;
        },
    },
});

export const {
    setData,
    setDataLength,
    setActivePage,
    addItemToData,
    deleteItemFromData,
} = dataSlice.actions;
export default dataSlice.reducer;
